import { CustomDataAttrGtmClick } from '../../features/google/customDataType';
import { mainContentsUrls } from '../../features/url/mainContentsUrls';
import { DefaultProps } from '../../types/DefaultProps';
import { HttpsUrl } from '../../types/HttpsUrl';
import { NurseSenkaTheme } from '../../types/NurseSenkaTheme';
import { ButtonNav } from '../Button/ButtonNav';
import { ServiceLogo } from '../ServiceLogo';

import styles from './HeaderNavigation.module.scss';

import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC } from 'react';

type Props = DefaultProps & {
  appEnv: AppEnv;
};

type InnerNavigationParam = {
  id: number;
  link: HttpsUrl;
  active?: boolean;
  text: string;
  customDataAttrGtmClick: CustomDataAttrGtmClick;
};

const createInnerNavigationParams = (
  appEnv: AppEnv,
  theme?: NurseSenkaTheme,
): InnerNavigationParam[] => {
  const urls = mainContentsUrls(appEnv);

  const activeLounge = theme?.id === 'lounge';
  const activeSquare = theme?.id === 'square';
  const activeKnowledge = theme?.id === 'knowledge';

  return [
    {
      id: 1,
      link: urls.top,
      text: 'トップ',
      customDataAttrGtmClick: 'header-inner-navi-top',
    },
    {
      id: 2,
      link: urls.knowledge,
      active: activeKnowledge,
      text: '看護知識',
      customDataAttrGtmClick: 'header-inner-navi-lounge',
    },
    {
      id: 3,
      link: urls.square,
      active: activeSquare,
      text: '看護記事',
      customDataAttrGtmClick: 'header-inner-navi-square',
    },
    {
      id: 4,
      link: urls.lounge,
      active: activeLounge,
      text: '掲示板',
      customDataAttrGtmClick: 'header-inner-navi-knowledge',
    },
  ];
};

export const HeaderNavigation: FC<Props> = ({ theme, appEnv }) => {
  const params = createInnerNavigationParams(appEnv, theme);

  return (
    <ul className={styles['block-inner-flex']}>
      <li className={styles['header-logo']}>
        <ServiceLogo appEnv={appEnv} theme={theme} />
        <span className={styles['header-logo-text']}>
          {theme?.logoTitle as string}
        </span>
      </li>
      {params.map((param) => (
        <li className={styles['flex-li']} key={param.id}>
          <ButtonNav
            key={param.id}
            link={param.link}
            color="default"
            active={param.active}
            theme={theme}
            customDataAttrGtmClick={param.customDataAttrGtmClick}
          >
            {param.text}
          </ButtonNav>
        </li>
      ))}
    </ul>
  );
};
